module.exports = __webpack_public_path__ + "img/dissatisfied_green.0a412b45.png";